var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJaceToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3109_1493)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "url(#paint0_linear_3109_1493)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3945 31.0977V27.5257C17.7106 27.5257 22.0348 23.1677 22.0348 17.8104V16.7087H12.3945V13.1367H25.6055V17.8104C25.6055 25.1365 19.6786 31.0977 12.3945 31.0977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6055 6.82812H12.3945V10.3906H25.6055V6.82812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3109_1493",
    x1: 1.44727,
    y1: 36.627,
    x2: 38,
    y2: 2.63476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6AA50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#956010"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3109_1493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaceToken);
export default __webpack_public_path__ + "static/media/jace-token.b06c12dab5aa7b7967821a8d31503c1d.svg";
export { ForwardRef as ReactComponent };